import React, { useState, useMemo, useCallback, useEffect, useRef } from "react";
import { Table, Button, Input, Switch, Select, Dropdown, Checkbox, Space, Slider, Tooltip } from "antd";
import { ControlOutlined, FilterOutlined, ClearOutlined, DownOutlined, ImportOutlined, ExportOutlined, DownloadOutlined, CopyOutlined } from "@ant-design/icons";
import columns from "./columns";
import apiService from "./data";

import BundleDrawer from "../BundleDetailView/BundleDrawer";
import SimpleDrawer from "../SimpleProductsDetailView/SimpleDrawer";
import VariantDrawer from "../VariantProductsDetailView/VariantDrawer";
import CreateProductDrawer from "../SimpleProductsDetailView/CreateProducts/CreateProductDrawer";
import CreateBundle from "../BundleDetailView/CreateBundle/CreateBundle";
// import BundleDrawer from "../BundleDetailView/BundleDrawer";

import FullPageLoader from "../common/FullPageLoader";
import BulkAction from "../common/BulkAction/BulkAction"
import { exportToExcel } from "./exportToExcel"
import commonApiService from "../../config/common_api";
import globalData from '../../config/global_data';  // Import global data object
import ExcelImportPreview from "../common/ExcelImportPreview";
import tempFile from '../../assets/files/temp.xlsx';
import NoDataComponent from "../common/NoDataComponent";
import { useAuth } from "../UserAuth/AuthContext";
import { triggerNotification } from "../common/notify";
import common_api from "../../config/common_api";
const { Search } = Input;


const searchoptions = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'sapSku',
    label: 'SAP Sku',
  },
  {
    value: 'sapName',
    label: 'SAP Name',
  },
  {
    value: 'bcSku',
    label: 'BC SKU',
  },
  {
    value: 'sapCustomerNumber',
    label: 'SAP Customer',
  },
  {
    value: 'type',
    label: 'Type',
  },

];

const MasterTable = ({ globalList, setGlobalList }) => {
  const [data, setData] = useState([]);
  const [originaldata, setOriginaldata] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [slectedStore, setSlectedStore] = useState("Select Store");
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [simpleDrawerVisible, setSimpleDrawerVisible] = useState(false);
  const [variantDrawerVisible, setVariantDrawerVisible] = useState(false);
  const [createDrawerVisible, setCreateDrawerVisible] = useState(false);
  const [importclick, setImportclick] = useState(false);

  const [selectedDrawerdata, setSelectedDrawerdata] = useState({});
  const [copiedSku, setCopiedSku] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [stores, setstores] = useState([]);
  const [isloader, setisloader] = useState(true);
  const [alert, setAlert] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState(columns.map(col => col.dataIndex));
  const [searchSelectedOption, setSearchSelectedOption] = useState('all');
  const [stickyHeader, setStickyHeader] = useState(false);
  const tableWrapperRef = useRef(null);
  const [selectedFilter, setSelectedFilter] = useState(null);

  const selectedOptionLabel = searchoptions.find(opt => opt.value === searchSelectedOption)?.label || '';
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(100);
  const [selectedPriceRange, setSelectedPriceRange] = useState([0, 100]);
  const isAnyFilterApplied = searchText || (slectedStore && slectedStore !== "Select Store") || selectedFilter;
  const { userData } = useAuth();
  const [createBundleDrawerVisible, setBundleDrawerVisible] = useState(false);  
  

  const import_export_list = [
    {
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between', minWidth: 120 }}>
          <span>Export Selected</span>
          <span>{selectedRowKeys.length}</span>
        </div>
      ),
      key: '1',
      icon: <ExportOutlined />,
      disabled: selectedRowKeys.length <= 0 ? true : false
    },
    {
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between', minWidth: 120 }}>
          <span>Export All</span>
          <span>{data.length}</span>
        </div>
      ),
      key: '2',
      icon: <ExportOutlined />,
      disabled: data.length <= 0 ? true : false
    },

    {
      label: 'Import',
      key: '3',
      icon: <ImportOutlined />,
    },
    {
      label: 'Download Import template',
      key: '4',
      icon: <DownloadOutlined />,
    },
  ];
  const handleMenuClick = (e) => {
    if (e.key == 2) {

      handleAll()
    }
    if (e.key == 1) {
      handleExport()
    }
    if (e.key == 3) {
      setImportclick(true)
    }
    if (e.key == 4) {
      handleDownload()
    }
  }
  const menuProps = {
    items: import_export_list,
    onClick: handleMenuClick,
  };

  const applyAllFilters = async (filters = {}) => {
    const {
      search = searchText,
      store = slectedStore,
      filter = selectedFilter,
      priceRange = selectedPriceRange,
      original = originaldata,
      searchSelectedOption: selectedOption = searchSelectedOption, // new addition
    } = filters;

    let filtered = await original;

    // Filter by store
    if (store !== "" && store !== "all" && store !== "Select Store") {
      filtered = filtered.filter(item =>
        item.store.toLowerCase().includes(store.toLowerCase())
      );
    }

    // Filter by search text
    if (search && selectedOption !== "all" && typeof search === "string") {
      filtered = filtered.filter(item =>
        item[selectedOption]?.toLowerCase().includes(search.toLowerCase())
      );
    } else if (search && selectedOption === "all" && typeof search === "string") {
      filtered = await filtered.filter(item =>
        item.sapSku.toLowerCase().includes(search.toLowerCase()) ||
        item.sapName.toLowerCase().includes(search.toLowerCase()) ||
        item.sapCustomerNumber?.toLowerCase().includes(search.toLowerCase()) ||
        item.type?.toLowerCase().includes(search.toLowerCase())
      );
    }


    switch (filter) {
      case "All":
        setSelectedPriceRange([minPrice, maxPrice]);
        // filtered = filtered
        break;
      case "Products not live":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.active === 0);
        break;
      case "Products live":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.active === 1);
        break;
      case "Enrichment pending":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.enrichment === false);
        break;
      case "Low Stock":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.bcInventory < 5 && item.bcInventory !== "NA");
        break;
      case "Price":
        filtered = filtered.filter(item => {
          const msrp = parseFloat(item?.prdouct_data?.prod_msrp?.replace(/[^0-9.]/g, ''));
          return !isNaN(msrp) && msrp >= priceRange[0] && msrp <= priceRange[1];
        });
        break;
      case "Gift Product":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.bcSku.toLowerCase().includes("gift"));
        break;
      case "Incomplete Mapping":
        setSelectedPriceRange([minPrice, maxPrice]);
        filtered = filtered.filter(item => item.sapSku === "NA");
        break;
      default:
        break;
    }
    setData(filtered);
    // setCurrentPage(1);
  };


  useEffect(() => {
    const handleScroll = () => {
      if (tableWrapperRef.current) {
        const scrollTop = tableWrapperRef.current.scrollTop;
        setStickyHeader(scrollTop > 0); // enable sticky only when scrolling starts
      }
    };

    const wrapper = tableWrapperRef.current;
    if (wrapper) {
      wrapper.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (wrapper) {
        wrapper.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const fetchCommonData = async () => {
    await Promise.all([
      commonApiService.get_stores(),
      commonApiService.GetFrontendTabs(),
      commonApiService.get_sap_skus(),
      commonApiService.get_bc_skus(),
      commonApiService.get_all_category_tree(),
    ])
  }
  const fetchData = async () => {

    const apiData = await apiService.apidata();
    if (apiData && apiData.length > 0) {
      setGlobalList({ ...globalList, sap_datalist: apiData })
      setData(apiData);
      setOriginaldata(apiData);
      applyAllFilters({ original: apiData });

      if (drawerVisible) {
        applyAllFilters({ original: apiData });
      }
      setisloader(false);
    }else{
      setisloader(false);
    }

    if (globalData.store_list.length > 0) {
      setstores(globalData.store_list);
    }
  };

  useEffect(() => {
    if (!globalList || !globalList.sap_datalist || globalList.sap_datalist.length <= 0) {
      fetchData();
      // fetchCommonData();
    }
    const intr = setInterval(() => {
      if (globalData.store_list && globalData.store_list.length > 0) {
        clearInterval(intr)
        handleStorelist();
      }
    }, 100);
  }, []);

  useEffect(() => {
    if (globalList && globalList.sap_datalist) {
      if (globalList.sap_datalist !== originaldata) {
        setData(globalList.sap_datalist);
        setOriginaldata(globalList.sap_datalist);
        applyAllFilters({ original: globalList.sap_datalist });
      }
      setisloader(false);
    }
  }, [globalList, originaldata]);

  const handleStorelist = async () => {
    if (globalData.store_list.length > 0) {
      setstores(globalData.store_list);
      setSlectedStore('Select Store');
    }
  }
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = tempFile;
    link.download = "template.xlsx";
    link.click();
  };
  const handleExport = async () => {
    const selectedData = data.filter((item) =>
      selectedRowKeys.includes(item.key)
    );
    let finalExportData = []

    selectedData.forEach(async product => {
      let prodobj = {
        sap_name: product.sapName,
        sapSku: product.sapSku,
        prod_id: product.prod_id,
        bc_name: product.bc_name,
        sapCustomerNumber: product.sapCustomerNumber,
        bcSku: product.bcSku,
        type: product.type,
        active: product.active === 1 ? true : false,
        store: product.store,
        bcInventory: product.bcInventory,
        subscription: product.subscription,
        sapMsrp: product.sapMsrp,
      }
      let customdata = null
      if (product.custom_fields && product.custom_fields.length > 0) {
        customdata = product.custom_fields
      }
      if (customdata && globalData && globalData.attribute_tree.length > 0) {
        const mappedData = globalData.attribute_tree.map((item, index) => {
          let value = [{}]
          const pattern = new RegExp(item.attri_pattern);

          const return_data = customdata.filter(initem => pattern.test(initem.name ? initem.name : initem.key))
          for (let k = 0; k < return_data.length; k++) {
            const element = return_data[k];
            prodobj[element.name] = element.value
          }
        })
      }
      if (product.variant_data) {
        prodobj.variant_sku = product.variant_data.variant_sku
        prodobj.variant_id = product.variant_data.variant_id
        prodobj.prod_msrp = product.variant_data.prod_msrp
        prodobj.prod_sale_price = product.variant_data.prod_sale_price
      }

      finalExportData.push(prodobj)
    });

    exportToExcel(finalExportData);
  };
  const handleAll = async () => {
    const selectedData = data
    let finalExportData = []

    selectedData.forEach(async product => {
      let prodobj = {
        sap_name: product.sapName,
        sapSku: product.sapSku,
        prod_id: product.prod_id,
        bc_name: product.bc_name,
        sapCustomerNumber: product.sapCustomerNumber,
        bcSku: product.bcSku,
        type: product.type,
        active: product.active === 1 ? true : false,
        store: product.store,
        bcInventory: product.bcInventory,
        subscription: product.subscription,
        sapMsrp: product.sapMsrp,
        sapSku: product.sapSku
      }
      let customdata = null
      if (product.custom_fields && product.custom_fields.length > 0) {
        customdata = product.custom_fields
      }
      if (customdata && globalData && globalData.attribute_tree.length > 0) {
        const mappedData = globalData.attribute_tree.map((item, index) => {
          let value = [{}]
          const pattern = new RegExp(item.attri_pattern);

          const return_data = customdata.filter(initem => pattern.test(initem.name ? initem.name : initem.key))
          for (let k = 0; k < return_data.length; k++) {
            const element = return_data[k];
            prodobj[element.name] = element.value
          }
        })
      }
      if (product.variant_data) {
        prodobj.variant_sku = product.variant_data.variant_sku
        prodobj.variant_id = product.variant_data.variant_id
        prodobj.prod_msrp = product.variant_data.prod_msrp
        prodobj.prod_sale_price = product.variant_data.prod_sale_price
      }

      finalExportData.push(prodobj)
    });

    exportToExcel(finalExportData);
  };

  const activeFiltersCount = [
    searchText !== '',
    slectedStore && slectedStore !== 'all' && slectedStore !== 'Select Store',
    selectedFilter !== null,
    selectedPriceRange[0] !== minPrice || selectedPriceRange[1] !== maxPrice
  ].filter(Boolean).length;
  const handleFilterChange = (value) => {
    setSelectedFilter(value);
    applyAllFilters({ filter: value });
  };
  const openDrawer = useCallback((sapSku, store_id) => {

    const filteredData = originaldata.filter((item) =>
      item.sapSku.toLowerCase() == sapSku.toLowerCase() && item.store_id === store_id
    );

    if (filteredData[0]?.type === "Simple") {
      setSelectedDrawerdata(filteredData[0]);
      setSimpleDrawerVisible(true);

    }
    else if (filteredData[0]?.type === "Variant" && filteredData[0].variant_data.id) {
      let item = filteredData[0]
      const variant_obj = {
        prod_id: item.prod_id,
        key: item.key,
        bc_name: item.bc_name,
        bcSku: item.bc_sku,
        type: item.type,
        active: item.active,
        store: item.store, // static as per your example
        enrichment: 0,  // every 5th is false
        lastUpdated: item.lastUpdated, //new Date(item.updated_at).toLocaleString("en-GB"), // format date
        action: item.variant_data ? "Edit" : "create",
        variant_data: item.variant_arr,
        store_id: item.store_id,
        currency_symbol: item.currency_symbol,
        msrp: item.variant_data.prod_msrp,
        sale_price: item.variant_data.prod_sale_price,
        custom_fields: item.custom_fields,
        images: item.images,
        inventory_tracking: item.inventory_tracking,
        categories: item.categories,
        variant_options: item.variant_options,
        bc_url: item.bc_url
      }
      setSelectedDrawerdata(variant_obj);
      setVariantDrawerVisible(true);
    }
    else if (filteredData[0]?.type === "Bundle" && filteredData[0].prdouct_data) {
      let item = filteredData[0]


      const bundle_obj = {
        key: item.key,
        prod_id: item.prod_id,
        sapSku: item.sap_sku,
        sapName: item.product_name,
        sapCustomerNumber: item.sap_customer_number,
        sapPrice: `${item.currency_symbol}${item.sapPrice}`,
        sapMsrp: item.sap_data ? `${item.currency_symbol}${item.sapMsrp}` : "NA",
        availableStock: item.inventory_available,
        reservedStock: item.inventory_reserved,
        bcSku: item.bcSku,
        bc_name: item.bc_name,
        type: item.type,
        active: item.active,
        store: item.store, // static as per your example
        bcInventory: item.bcInventory,
        subscription: "Yes", // static as per your example
        enrichment: item.enrichment,  // every 5th is false
        lastUpdated: item.lastUpdated, //new Date(item.updated_at).toLocaleString("en-GB"), // format date
        config: item.modifier_data?.config,
        modifier_data: item.modifier_data,
        msrp: item.prdouct_data.prod_msrp,
        sale_price: item.prdouct_data.prod_sale_price,
        currency_symbol: item.currency_symbol,
        custom_fields: item.custom_fields,
        categories: item.categories,
        images: item.images,
        store_id: item.store_id,
        bc_url: item.bc_url,
        bundle_sap_Array: item.bundle_sap_Array
      }
      setSelectedDrawerdata(bundle_obj);
      setDrawerVisible(true);
    }
    else if (filteredData[0]?.type === "Bundle" ) {
      let item = filteredData[0]
      setSelectedDrawerdata(filteredData[0]);
      setBundleDrawerVisible(true);
    }
    else {
      setSelectedDrawerdata(filteredData[0]);
      setCreateDrawerVisible(true)
    }
  }, [originaldata]);

  const closeDrawer = () => setDrawerVisible(false);
  const closeSimpleDrawer = () => setSimpleDrawerVisible(false);
  const closeVariantDrawer = () => setVariantDrawerVisible(false);
  const closeCreateDrawer = () => setCreateDrawerVisible(false);
  const createBundleCloseDrawer = () => setBundleDrawerVisible(false);

  const handleSearch = (value) => {
    setSearchText(value);
    applyAllFilters({ search: value });
  };
  const handleStoreChange = (value) => {
    setSlectedStore(value);
    applyAllFilters({ store: value });

  };

  const handleSearchChange = (value) => {
    setSearchSelectedOption(value);
    applyAllFilters({ searchSelectedOption: value });
  };
  const handleToggleActive = useCallback(async (checked, rec) => {
    setisloader(true);
    let filterdata = originaldata.find(item => rec.key === item.key);
    let responsedata = await apiService.active_inactive_status(filterdata, checked);
    if (responsedata) {
      setData(prevData =>
        prevData.map(item =>
          rec.prod_id === item.prod_id && rec.sapSku === item.sapSku && rec.store === item.store ? { ...item, active: checked } : item
        )
      );

      await fetchData(responsedata);
      let alldata = await common_api.set_all_madded_data_to_variables(globalList, responsedata)
      if (alldata) {
        await setGlobalList(alldata)
      }
      setisloader(false);
      triggerNotification(responsedata)
    }
    setisloader(false);


  }, [originaldata, fetchData]);

  const handleColumnToggle = (dataIndex) => {
    setVisibleColumns(prev =>
      prev.includes(dataIndex)
        ? prev.filter(col => col !== dataIndex)
        : [...prev, dataIndex]
    );
  };

  const columnMenu = {
    items: columns.map(col => ({
      key: col.dataIndex,
      label: (
        <Checkbox
          checked={visibleColumns.includes(col.dataIndex)}
          onChange={() => handleColumnToggle(col.dataIndex)}
        >
          {col.title}
        </Checkbox>
      ),
    })),
  };


  const updatedColumns = useMemo(() => {
    return columns
      .filter(col => visibleColumns.includes(col.dataIndex))
      .map(col => {
        if (col.dataIndex === "active") {
          return {
            ...col,
            render: (_, record) => (
              <Switch
                disabled={record.bcInventory === "NA" || userData.data?.access !== "ALL"}
                checked={record.active}
                onChange={(checked) => handleToggleActive(checked, record)}
              />
            )
          };
        }
        if (col.dataIndex === "sapSku") {
          return {
            ...col,
            render: (_, record) => (
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  position: 'relative',
                }}
                onMouseEnter={(e) => {
                  const icon = e.currentTarget.querySelector('.copy-icon');
                  if (icon) icon.style.opacity = 1;
                }}
                onMouseLeave={(e) => {
                  const icon = e.currentTarget.querySelector('.copy-icon');
                  if (icon) icon.style.opacity = 0;
                }}
              >
                <Button
                  type="link"
                  onClick={() => openDrawer(record.sapSku, record.store_id)}
                  style={{ padding: 0 }}
                >
                  {record.sapSku}
                </Button>
                <Tooltip title={copiedSku === record.sapSku ? "Copied" : "Copy"}>
                  <CopyOutlined
                    className="copy-icon"
                    onClick={() => {
                      navigator.clipboard.writeText(record.sapSku);
                      setCopiedSku(record.sapSku);
                      setTimeout(() => setCopiedSku(null), 1500);
                    }}
                    style={{
                      marginLeft: 6,
                      color: copiedSku === record.sapSku ? '#52c41a' : '#999',
                      cursor: 'pointer',
                      opacity: 0,
                      transition: 'opacity 0.3s ease, color 0.3s ease',
                    }}
                  />
                </Tooltip>
              </span>
            )
          };
        }
        return col;
      });
  }, [handleToggleActive, visibleColumns, openDrawer, copiedSku]);

  return (
    <div>
      <div className="TableFilterBox">
        <Select
          placeholder="Filter"
          style={{ width: 180 }}
          suffixIcon={<FilterOutlined style={{ color: "rgba(0, 0, 0, 0.88)" }} />}
          value={selectedFilter}
          className="filterSelect"
          onChange={handleFilterChange}
          options={[
            { value: "All", label: "All" },
            { value: "Products not live", label: "Products not live" },
            { value: "Products live", label: "Products live" },
            { value: "Enrichment pending", label: "Enrichment pending" },
            { value: "Low Stock", label: "Low Stock" },
          ]}
        />

        {selectedFilter === "Price" && (
          <Slider
            className="rangeSlider"
            range
            step={1}
            min={minPrice}
            max={maxPrice}
            value={selectedPriceRange}
            onChange={(value) => {
              setSelectedPriceRange(value);
              applyAllFilters({ priceRange: value });
            }}
          />
        )}
        <Select
          placeholder="Stores"
          style={{ width: 120 }}
          value={slectedStore}
          defaultValue="Select Store"
          options={stores}
          onChange={handleStoreChange}
        />
        <Space>
          <Space.Compact>


            <Select className="searchoptionsSelect" defaultValue="" value={searchSelectedOption} options={searchoptions} onChange={handleSearchChange}
            />
            <Search
              placeholder={selectedOptionLabel ? `${selectedOptionLabel === "All" ? "Search" : "Enter " + selectedOptionLabel}` : ""}
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 250 }}
              allowClear
              enterButton
            />
          </Space.Compact>
        </Space>
        {isAnyFilterApplied && (
          <Button
            onClick={() => {
              setSearchText('');
              setSlectedStore('Select Store');
              setSelectedFilter(null);
              setSelectedPriceRange([minPrice, maxPrice]); // Reset slider
              setData(originaldata);
              setSearchSelectedOption('all'); // Reset search option
              // setCurrentPage(1); // Optionally reset to page 1
            }}
            className="ClearAllFiltersBtn"

          >
            <ClearOutlined style={{ marginRight: 4 }} />
            {activeFiltersCount === 1 ? 'Clear Filters' : 'Clear Filters'}
          </Button>
        )}
        <Dropdown menu={{ ...columnMenu, className: 'ColumnMenuClass' }} trigger={["click"]} placement="bottomRight" className="TableSettings">
          <Button icon={<ControlOutlined />} />
        </Dropdown>

        <div className="RightBox" style={{ display: "flex", gap: 8 }}>
          {userData?.data?.access === "ALL" && (
            <BulkAction disabled={selectedRowKeys.length <= 0} selected_data={selectedRowKeys} originaldata={originaldata} setisloader={setisloader} reload={fetchData} globalList={globalList} setGlobalList={setGlobalList} />
          )}
          {userData?.data?.access === "ALL" && (
            <Dropdown menu={menuProps} trigger={["click"]}>
              <Button>
                <Space>
                  Import/ Export
                  <DownOutlined />
                </Space>
              </Button>
            </Dropdown>
          )}
          <ExcelImportPreview
            importclick={importclick}
            onComplete={() => setImportclick(false)}
            setisloader={setisloader}
            reload={fetchData}
          />
          {/* <Socket/> */}

        </div>
      </div>

      <FullPageLoader isloader={isloader} />
      <div
        className="TableBox"
        ref={tableWrapperRef}
        style={{ maxHeight: 700, overflow: 'auto' }}
      >
        {data && data.length > 0 ? <Table
          rowSelection={{
            selectedRowKeys,
            onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
          }}
          columns={updatedColumns}
          dataSource={data}
          scroll={{ x: '100%', y: 500 }}
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: data.length,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setPageSize(pageSize);
            },
            showTotal: (total) =>
              `Total ${total} items${selectedRowKeys.length > 0 ? ` | Selected: ${selectedRowKeys.length}` : ''}`,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            position: ['bottomLeft'],
          }}
          bordered
          sticky={stickyHeader ? { offsetHeader: 0 } : false}
        /> : <div >
          <NoDataComponent />
        </div>}
      </div>

      {drawerVisible && <BundleDrawer onProductCreate={fetchData} visible={drawerVisible} onClose={closeDrawer} selected_prod_data={selectedDrawerdata} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}
      {simpleDrawerVisible && <SimpleDrawer onProductCreate={fetchData} visible={simpleDrawerVisible} onClose={closeSimpleDrawer} selected_prod_data={selectedDrawerdata} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}
      {variantDrawerVisible && <VariantDrawer onProductCreate={fetchData} visible={variantDrawerVisible} onClose={closeVariantDrawer} selected_prod_data={selectedDrawerdata} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}
      {createDrawerVisible && <CreateProductDrawer onProductCreate={fetchData} visible={createDrawerVisible} onClose={closeCreateDrawer} selected_prod_data={selectedDrawerdata} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}
      {createBundleDrawerVisible && <CreateBundle visible={createBundleDrawerVisible} onClose={createBundleCloseDrawer} selected_prod_data={selectedDrawerdata} setisloader={setisloader} globalList={globalList} setGlobalList={setGlobalList} />}
      {/* {editBundleDrawerVisible && <BundleDrawer visible={editBundleDrawerVisible} onClose={editBundleCloseDrawer} onProductCreate={fetchData} setisloader={setisloader} />} */}
    
    </div>
  );
};

export default MasterTable;
